function millToSoc(time) {
  return time / 1000;
}
const qs = {
  minimalValidScore: 30,
  minimumNumberHalfReps: 4,
  reversalTolerance: 0.4,
  noiseLevel: 0.05,
  trendThreshold: 4,

  correctTimeInSensorData: function (measurements) {
    const correctionTime = measurements[0].time;
    const measurementsAfterCorrection = [];
    // make new array of measurements after correct the time
    [...measurements].forEach((i, index) => {
      const measurements2 = {
        time: i.time - correctionTime,
        halfRepetition: i.halfRepetition,
        referencePosition: i.referencePosition,
        actualPosition: i.actualPosition,
      };
      let checkMeasurements = measurements[index + 1]
        ? measurements[index + 1].halfRepetition
        : measurements[index].halfRepetition;
      if (measurements2.halfRepetition <= checkMeasurements) {
        measurementsAfterCorrection.push(measurements2);
      }
    });
    const reversalIndexes = qs.calculateReversalIndexes([...measurementsAfterCorrection]);
    measurements = [...measurementsAfterCorrection];
    return { measurements, reversalIndexes };
  },

  correctWrongSensorData: function (measurements) {
    function checkRef(arr) {
      // try to find the start point of the second rep in measurements
      return arr.referencePosition < 0.002 && arr.halfRepetition > 2;
    }
    const copyOfMeasurements = [...measurements];
    // try to find where second rep start
    const startIndex = [...copyOfMeasurements].findIndex(checkRef);
    // remove first rep because it start with wrong ref
    const measurements2 = [...copyOfMeasurements].splice(startIndex);
    const correctionTime = measurements2[0].time;
    const measurementsAfterCorrection = [];
    // make new array of measurements after correct the time and hr
    [...measurements2].forEach((i) => {
      const measurements3 = {
        time: i.time - correctionTime,
        halfRepetition: i.halfRepetition - 2,
        referencePosition: i.referencePosition,
        actualPosition: i.actualPosition,
      };
      measurementsAfterCorrection.push(measurements3);
    });
    const reversalIndexes = qs.calculateReversalIndexes([...measurementsAfterCorrection]);
    measurements = [...measurementsAfterCorrection];
    return { measurements, reversalIndexes };
  },

  ensureChronological: function (measurements) {
    let nrSwaps = 0;
    // Start looping at i = 1, so there is a measurement at i-1.
    for (var i = 1; i < measurements.length; ++i) {
      if (measurements[i - 1].time > measurements[i].time) {
        // find the measurement to swap with
        var outOfOrderMeasurement = measurements[i];
        var j = i - 1;
        while (j > 0 && measurements[j - 1].time > outOfOrderMeasurement.time) --j;
        measurements[i] = measurements[j];
        measurements[j] = outOfOrderMeasurement;
      }
    }
  },

  calculateReversalIndexes: function (measurements) {
    let history = '';
    const reversalTolerance = qs.reversalTolerance;
    const reversalTolerance1 = 1 - reversalTolerance;
    let reversalIndexes = [];
    // The start-index of the range of the next reversal.
    let hrStart = 0;
    // How far to look back for trend at end.
    let trendFromIndex = 0;
    // Start looping at i = 1, so there is a measurement at i-1.
    for (let i = 1; i < measurements.length; ++i) {
      let p = measurements[i - 1]; // previous
      let m = measurements[i]; // current measurement
      // Use atEnd to find the last reversal, before an unfinished
      // half-repetition.
      let atEnd = i == measurements.length - 1;
      let trendAtEnd = atEnd ? qs.trendAtEnd(measurements, trendFromIndex) : 0;
      // Find the boundaries for ranges that contain a reversal, using the
      // tolerance, stopping at the last measurement.
      if (
        p.referencePosition <= reversalTolerance &&
        (m.referencePosition > reversalTolerance || (atEnd && trendAtEnd == 1))
      ) {
        trendFromIndex = i;
        // Lower end of upward slope of reference position.
        history += `‿/(${i} / ${measurements[i].time})  `;

        // Look for a minimum reversal in the previous range, unless this is
        // the first range.
        if (hrStart > 0) {
          let revIndex = qs.findReversal(
            -1,
            measurements.map((m) => m.actualPosition),
            hrStart,
            i,
          );
          reversalIndexes.push(revIndex);
        }
      } else if (
        p.referencePosition <= reversalTolerance1 &&
        (m.referencePosition > reversalTolerance1 || (atEnd && trendAtEnd == 1))
      ) {
        trendFromIndex = i;
        // Higher end of upward slope of reference position.
        history += `/⁀(${i} / ${measurements[i].time})  `;

        // Start looking for the next reversal from here.
        hrStart = i;
      } else if (
        p.referencePosition >= reversalTolerance1 &&
        (m.referencePosition < reversalTolerance1 || (atEnd && trendAtEnd == -1))
      ) {
        trendFromIndex = i;
        // Higher end of downward slope of reference position.
        history += `⁀\\(${i} / ${measurements[i].time})  `;

        let revIndex = qs.findReversal(
          1,
          measurements.map((m) => m.actualPosition),
          hrStart,
          i,
        );
        reversalIndexes.push(revIndex);
      } else if (
        p.referencePosition >= reversalTolerance &&
        (m.referencePosition < reversalTolerance || (atEnd && trendAtEnd == -1))
      ) {
        trendFromIndex = i;
        // Lower end of downward slope of reference position.
        history += `\\‿(${i} / ${measurements[i].time})  `;
        hrStart = i;
      }
    }
    return reversalIndexes;
  },

  trendAtEnd: function (measurements, fromIndex) {
    fromIndex = fromIndex || 0;
    var trendScore = 0; // keeps track of upward or downward movement
    var trendHistory = `from ${measurements[fromIndex].time} (${fromIndex}) > `;
    var lastAct = measurements[measurements.length - 1].actualPosition; // last actual

    for (
      var i = measurements.length - 2;
      i >= fromIndex && Math.abs(trendScore) < qs.trendThreshold;
      --i
    ) {
      const previousAct = measurements[i].actualPosition;
      const changePosPerSec =
        (previousAct - lastAct) / (measurements[i + 1].time - measurements[i].time);
      if (changePosPerSec > qs.noiseLevel) {
        --trendScore;
        trendHistory += '-';
      } else if (changePosPerSec < -qs.noiseLevel) {
        ++trendScore;
        trendHistory += '+';
      } else trendHistory += '.';
      lastAct = previousAct;
    }

    const trendAtEnd = trendScore > 0 ? 1 : trendScore < 0 ? -1 : 0;
    return trendAtEnd;
  },

  findReversal: function (minMax, series, iStart, iEnd) {
    // Zoom in on one point, reached when iStart is equal to iEnd.
    while (iStart < iEnd) {
      var iMid = Math.floor((iStart + iEnd) / 2);

      // Compute the averages of the two halved ranges.
      var average0 = 0;
      var average1 = 0;
      // A loop is not elegant, but more efficient than Array.slice().
      for (var i = iStart; i <= iMid; ++i) {
        average0 += series[i];
      }
      for (var i = iMid + 1; i <= iEnd; ++i) {
        average1 += series[i];
      }
      average0 = average0 / (iMid + 1 - iStart);
      average1 = average1 / (iEnd - iMid);
      // Compare the averages, and choose the halved range to continue
      // searching.
      if (minMax > 0 ? average0 > average1 : average0 < average1) {
        // Look for maximum reversal.
        iEnd = iMid;
      } else {
        // Look for minimum reversal.
        iStart = iMid + 1;
      }
    }
    return iStart;
  },

  /**
   * Penalty table for tempo, mapping time difference (seconds) between
   * reference reversal and actual reversal to score penalty.
   */
  tempoPenaltyTable: [
    [0.1, 0],
    [0.2, 5],
    [0.3, 10],
    [0.5, 15],
    [0.7, 20],
    [1.0, 30],
    [1.5, 40],
    [2.0, 50],
    [2.5, 60],
    [3.0, 70],
    [4.0, 80],
    [5.0, 90],
    [Number.POSITIVE_INFINITY, 100], // everything over 5.0
  ],

  calculateTempoScore: function (machineGroupId, measurements, reversalIndexes) {
    if (reversalIndexes.length < qs.minimumNumberHalfReps) {
      return 0;
    }

    var hrScores = []; // scores for half reps.
    for (var hr = 0; hr < reversalIndexes.length; ++hr) {
      var refReversalTime = (hr + 1) * 10.0; // Reference reverses every 10
      // seconds.
      var actReversalTime = millToSoc(measurements[reversalIndexes[hr]].time);
      var timeDiff = Math.abs(refReversalTime - actReversalTime); // seconds
      var penalty = qs.tempoPenaltyTable.find((pt) => pt[0] >= timeDiff)[1];
      hrScores.push(100 - penalty);
    }
    if (hrScores.length == 0) return 0; // no reversals during exercise
    var score = hrScores.reduce((total, score) => total + score) / hrScores.length; // compute
    return score >= qs.minimalValidScore ? Math.round(score) : 0;
  },

  rangePenaltyTable: {
    mg0: [
      [-30, 100],
      [-25, 90],
      [-22, 80],
      [-19, 70],
      [-16, 60],
      [-13, 50],
      [-10, 40],
      [-7, 30],
      [-3, 15],
      [-2, 10],
      [-1, 5],
      [1, 0],
      [2, 5],
      [3, 10],
      [5, 15],
      [7, 20],
      [10, 30],
      [13, 40],
      [16, 50],
      [19, 60],
      [22, 70],
      [25, 80],
      [30, 90],
      [Number.POSITIVE_INFINITY, 100], // everything over 30
    ],
    mg1: [
      [-30, 100],
      [-25, 90],
      [-22, 80],
      [-19, 70],
      [-16, 60],
      [-13, 50],
      [-10, 40],
      [-7, 30],
      [-3, 15],
      [-2, 10],
      [-1, 5],
      [1, 0],
      [2, 5],
      [3, 10],
      [5, 15],
      [7, 20],
      [10, 30],
      [13, 40],
      [16, 50],
      [19, 60],
      [22, 70],
      [25, 80],
      [30, 90],
      [Number.POSITIVE_INFINITY, 100], // everything over 30
    ],
  },

  rangeHrScoreWeight: {
    mg0: [100],
    mg1: [100, 100, 100, 100, 75, 75, 50, 50, 0],
  },

  calculateRangeScore: function (machineGroupId, measurements, reversalIndexes) {
    if (reversalIndexes.length < qs.minimumNumberHalfReps) {
      return 0;
    }

    var hrScores = []; // scores for half reps.
    for (var hr = 0; hr < reversalIndexes.length; ++hr) {
      var refReversalPosition = (hr + 1) % 2; // 1.0, 0.0, 1.0, 0.0, ....
      var actReversalPosition = measurements[reversalIndexes[hr]].actualPosition;
      // The meaning of over- and under-extension switches every HR.
      // Note that positionDiff is a percentage (0..100) of calibrated range.
      var positionDiff =
        100 *
        (hr % 2
          ? actReversalPosition - refReversalPosition
          : refReversalPosition - actReversalPosition);
      var penalty = qs.rangePenaltyTable[machineGroupId].find((pt) => pt[0] >= positionDiff)[1];
      hrScores.push(100 - penalty);
    }
    if (hrScores.length == 0) return 0; // panic!
    // Compute the weighted average score.
    var total_weight = hrScores.reduce(
      (t_w, score, hr) => {
        var weightTable = qs.rangeHrScoreWeight[machineGroupId];
        var weight = weightTable[Math.min(hr, weightTable.length - 1)];
        return [t_w[0] + score * weight, t_w[1] + weight];
      },
      [0, 0],
    );
    var score = total_weight[0] / total_weight[1];
    return score >= qs.minimalValidScore ? Math.round(score) : 0;
  },

  /**
   * Penalty table for rhythm, mapping machineGroupId to a table mapping
   * position divergence (as percentage of calibrated range) to score penalty.
   */
  rhythmPenaltyTable: {
    mg0: [
      [1, 0],
      [2, 5],
      [3, 10],
      [5, 15],
      [7, 20],
      [10, 30],
      [13, 40],
      [16, 50],
      [19, 60],
      [22, 70],
      [25, 80],
      [30, 90],
      [Number.POSITIVE_INFINITY, 100], // everything above 30
    ],
    mg1: [
      [1, 0],
      [2, 5],
      [3, 10],
      [5, 15],
      [7, 20],
      [10, 30],
      [13, 40],
      [16, 50],
      [19, 60],
      [22, 70],
      [25, 80],
      [30, 90],
      [Number.POSITIVE_INFINITY, 100], // everything above 30
    ],
  },

  rhythmHrScoreWeight: {
    mg0: [100],
    mg1: [100, 100, 100, 100, 75, 75, 50, 50, 0],
  },

  calculateRhythmScore: function (machineGroupId, measurements, reversalIndexes) {
    if (reversalIndexes.length < qs.minimumNumberHalfReps) {
      return 0;
    }

    var maxDivergences = []; // max. divergences for all half reps, 0 .. 100.
    var lastReversalIndex = reversalIndexes[reversalIndexes.length - 1];
    for (var i = 0; i < lastReversalIndex; ++i) {
      var m = measurements[i];
      var hrTime = millToSoc(m.time) % 10; // time within half-rep
      if (hrTime > 2 && hrTime < 8) {
        var hr = Math.floor(millToSoc(m.time) / 10); // half rep, starting at 0
        var divergence = 100 * Math.abs(m.referencePosition - m.actualPosition); // 0 .. 100
        if (divergence > (maxDivergences[hr] || 0)) {
          maxDivergences[hr] = divergence;
        }
      }
    }
    var hrScores = maxDivergences.map((divergence, hr) => {
      var penalty = qs.rhythmPenaltyTable[machineGroupId].find((pt) => pt[0] >= divergence)[1];
      return 100 - penalty;
    }); // scores for half reps.

    if (hrScores.length == 0) return 0; // panic!
    // Compute the weighted average score.
    var total_weight = hrScores.reduce(
      (t_w, score, hr) => {
        var weightTable = qs.rhythmHrScoreWeight[machineGroupId];
        var weight = weightTable[Math.min(hr, weightTable.length - 1)];
        return [t_w[0] + score * weight, t_w[1] + weight];
      },
      [0, 0],
    );
    var score = total_weight[0] / total_weight[1];

    return score >= qs.minimalValidScore ? Math.round(score) : 0;
  },

  scoreWeightInTotal: {
    tempo: 30,
    rhythm: 30,
    range: 40,
  },

  calculateTotalQualityScore: function (scores) {
    var totalScore = 0;
    var totalWeight = 0;
    var invalid = false;
    ['tempo', 'rhythm', 'range'].forEach(function (score) {
      if (scores[score] > qs.minimalValidScore) {
        totalScore += scores[score] * qs.scoreWeightInTotal[score];
        totalWeight += qs.scoreWeightInTotal[score];
      } else {
        invalid = true;
      }
    });
    if (invalid) {
      return 0;
    } else {
      return totalWeight > 0 ? Math.round(totalScore / totalWeight) : 0;
    }
  },

  graphData: function (measurements, interval) {
    let measurementsAfterCorrection;

    var graphData = [];
    // Use the first measurement to set the time.
    if (measurements.length > 0) {
      // var nextTime = measurements[0].time;
      for (var i = 0; i < measurements.length; ++i) {
        // if (measurements[i].time >= nextTime) {
        graphData.push({
          date: measurements[i].time,
          act: measurements[i].actualPosition,
          ref: measurements[i].referencePosition,
        });
        // nextTime += interval;
        // }
      }
    }
    return graphData;
  },

  reversalTimes: function (measurements, reversalIndexes) {
    return reversalIndexes.map((ridx) => measurements[ridx].time);
  },
};

function getBestScore(results, allSessions, machineId) {
  let total = [];
  let range = [];
  let rhythm = [];
  let tempo = [];
  allSessions.forEach((ele) => {
    if (ele.exercises) {
      ele.exercises.forEach((exercise) => {
        if (exercise.machineId == machineId) {
          exercise.qs_average && exercise.qs_average > 0 ? total.push(exercise.qs_average) : '';
          exercise.qs_range && exercise.qs_range > 0 ? range.push(exercise.qs_range) : '';
          exercise.qs_rhythm && exercise.qs_rhythm > 0 ? rhythm.push(exercise.qs_rhythm) : '';
          exercise.qs_tempo && exercise.qs_tempo ? tempo.push(exercise.qs_tempo) : '';
          // if (
          //   exercise.qs_average &&
          //   exercise.qs_average > 0 &&
          //   exercise.qs_range &&
          //   exercise.qs_range > 0 &&
          //   exercise.qs_rhythm &&
          //   exercise.qs_rhythm > 0 &&
          //   exercise.qs_tempo &&
          //   exercise.qs_tempo > 0
          // ) {
          //   range.push(exercise.qs_range);
          //   rhythm.push(exercise.qs_rhythm);
          //   tempo.push(exercise.qs_tempo);
          // }
        }
      });
    }
  });
  let bestScore = '';

  if (results.average >= Math.max.apply(0, total)) {
    bestScore = 'allTimeBest';
  } else if (results.average >= Math.max.apply(0, total.slice(0, 5))) {
    bestScore = 'currentBest';
  } else if (results.rhythm >= Math.max.apply(0, rhythm.slice(0, 5))) {
    bestScore = 'rhythm';
  } else if (results.tempo >= Math.max.apply(0, tempo.slice(0, 5))) {
    bestScore = 'tempo';
  } else if (results.range >= Math.max.apply(0, range.slice(0, 5))) {
    bestScore = 'range';
  }
  return bestScore;
}

function getOverAllQs(exercises, lastSession) {
  let overall_QS = {};
  if (exercises.length > 2 && lastSession) {
    let allAverage = [];
    let allRange = [];
    let allRhythm = [];
    let allTempo = [];
    exercises.forEach((item) => {
      if (item.qs_average && item.qs_average > 30) {
        allAverage.push(item.qs_average);
      }
      if (item.qs_range && item.qs_range > 30) {
        allRange.push(item.qs_range);
      }
      if (item.qs_rhythm && item.qs_rhythm > 30) {
        allRhythm.push(item.qs_rhythm);
      }
      if (item.qs_tempo && item.qs_tempo > 30) {
        allTempo.push(item.qs_tempo);
      }
    });

    if (allAverage && allAverage.length > 1) {
      overall_QS.qs_average = Math.round(allAverage.reduce((a, b) => a + b, 0) / allAverage.length);
    } else {
      overall_QS.qs_average = 0;
    }

    if (allRange && allRange.length > 1) {
      overall_QS.qs_range = Math.round(allRange.reduce((a, b) => a + b, 0) / allRange.length);
    }

    if (allRhythm && allRhythm.length > 1) {
      overall_QS.qs_rhythm = Math.round(allRhythm.reduce((a, b) => a + b, 0) / allRhythm.length);
    }

    if (allTempo && allTempo.length > 1) {
      overall_QS.qs_tempo = Math.round(allTempo.reduce((a, b) => a + b, 0) / allTempo.length);
    }
  } else {
    overall_QS = 0;
  }

  return overall_QS;
}
function computeQualityScores(measurements, machineName) {
  try {
    var machineGroupId = machineName.indexOf('duction') >= 0 ? 'mg1' : 'mg0';
    // qs.ensureChronological(measurements);
    var reversalIndexes = qs.calculateReversalIndexes(measurements);
    var tempoScore = Math.round(
      qs.calculateTempoScore(machineGroupId, measurements, reversalIndexes),
    );
    var rangeScore = Math.round(
      qs.calculateRangeScore(machineGroupId, measurements, reversalIndexes),
    );
    var rhythmScore = Math.round(
      qs.calculateRhythmScore(machineGroupId, measurements, reversalIndexes),
    );
    var totalQualityScore = Math.round(
      qs.calculateTotalQualityScore({ tempo: tempoScore, range: rangeScore, rhythm: rhythmScore }),
    );
    var graphData = qs.graphData(measurements, 0.2);

    var reversalTimes = qs.reversalTimes(measurements, reversalIndexes);
    return {
      average: totalQualityScore,
      tempo: tempoScore,
      rhythm: rhythmScore,
      range: rangeScore,
      graphData: graphData,
      reversalTimes: reversalTimes,
    };
  } catch (ex) {
    console.error(ex);
    return {};
  }
}

// function getAllWeights(results, allSessions, machineId) {
//   let total = [];
//   let range = [];
//   let rhythm = [];
//   let tempo = [];
//   allSessions.forEach((ele) => {
//     if (ele.exercises) {
//       ele.exercises.forEach((exercise) => {
//         if (exercise.machineId == machineId) {
//           if (
//             exercise.qs_average &&
//             exercise.qs_average > 0 &&
//             exercise.qs_range &&
//             exercise.qs_range > 0 &&
//             exercise.qs_rhythm &&
//             exercise.qs_rhythm > 0 &&
//             exercise.qs_tempo &&
//             exercise.qs_tempo > 0
//           ) {
//             total.push(exercise.qs_average);
//             range.push(exercise.qs_range);
//             rhythm.push(exercise.qs_rhythm);
//             tempo.push(exercise.qs_tempo);
//           }
//         }
//       });
//     }
//   });

//   let allWeights = { average: 0, rhythm: 0, tempo: 0, range: 0 };

//   if (results.average >= Math.max.apply(0, total)) {
//     allWeights.average = results.average;
//   } else {
//     allWeights.average = Math.max.apply(0, total);
//   }

//   if (results.rhythm >= Math.max.apply(0, rhythm)) {
//     allWeights.rhythm = results.rhythm;
//   } else {
//     allWeights.rhythm = Math.max.apply(0, rhythm);
//   }

//   if (results.tempo >= Math.max.apply(0, tempo)) {
//     allWeights.tempo = results.tempo;
//   } else {
//     allWeights.tempo = Math.max.apply(0, tempo);
//   }
//   if (results.range >= Math.max.apply(0, range)) {
//     allWeights.range = results.range;
//   } else {
//     allWeights.range = Math.max.apply(0, range);
//   }
//   return allWeights;
// }
function getAllWeights(results, allSessions, machineId) {
  const allWeights = { average: 0, rhythm: 0, tempo: 0, range: 0 };
  const metrics = { total: [], range: [], rhythm: [], tempo: [] };

  // Helper function to calculate max values
  const getMax = (resultValue, metricArray) => Math.max(resultValue, Math.max(0, ...metricArray));

  // Process allSessions and collect metrics
  allSessions.forEach(({ exercises }) => {
    if (exercises) {
      exercises.forEach(({ machineId: exMachineId, qs_average, qs_range, qs_rhythm, qs_tempo }) => {
        if (
          exMachineId === machineId &&
          qs_average > 0 &&
          qs_range > 0 &&
          qs_rhythm > 0 &&
          qs_tempo > 0
        ) {
          metrics.total.push(qs_average);
          metrics.range.push(qs_range);
          metrics.rhythm.push(qs_rhythm);
          metrics.tempo.push(qs_tempo);
        }
      });
    }
  });

  // Calculate max values for each metric
  allWeights.average = getMax(results.average, metrics.total);
  allWeights.rhythm = getMax(results.rhythm, metrics.rhythm);
  allWeights.tempo = getMax(results.tempo, metrics.tempo);
  allWeights.range = getMax(results.range, metrics.range);

  return allWeights;
}

// function getThisWeight(results, allSessions, machineId, weight) {
//   let total = [];
//   let range = [];
//   let rhythm = [];
//   let tempo = [];
//   allSessions.forEach((ele) => {
//     if (ele.exercises) {
//       ele.exercises.forEach((exercise) => {
//         if (exercise.machineId == machineId && exercise.weight == weight) {
//           if (
//             exercise.qs_average &&
//             exercise.qs_average > 0 &&
//             exercise.qs_range &&
//             exercise.qs_range > 0 &&
//             exercise.qs_rhythm &&
//             exercise.qs_rhythm > 0 &&
//             exercise.qs_tempo &&
//             exercise.qs_tempo > 0
//           ) {
//             total.push(exercise.qs_average);
//             range.push(exercise.qs_range);
//             rhythm.push(exercise.qs_rhythm);
//             tempo.push(exercise.qs_tempo);
//           }
//         }
//       });
//     }
//   });

//   let thisWeight = { average: 0, rhythm: 0, tempo: 0, range: 0 };

//   if (results.average >= Math.max.apply(0, total)) {
//     thisWeight.average = results.average;
//   } else {
//     thisWeight.average = Math.max.apply(0, total);
//   }

//   if (results.rhythm >= Math.max.apply(0, rhythm)) {
//     thisWeight.rhythm = results.rhythm;
//   } else {
//     thisWeight.rhythm = Math.max.apply(0, rhythm);
//   }

//   if (results.tempo >= Math.max.apply(0, tempo)) {
//     thisWeight.tempo = results.tempo;
//   } else {
//     thisWeight.tempo = Math.max.apply(0, tempo);
//   }
//   if (results.range >= Math.max.apply(0, range)) {
//     thisWeight.range = results.range;
//   } else {
//     thisWeight.range = Math.max.apply(0, range);
//   }
//   return thisWeight;
// }

function getThisWeight(results, allSessions, machineId, weight) {
  const thisWeight = { average: 0, rhythm: 0, tempo: 0, range: 0 };
  const metrics = { total: [], range: [], rhythm: [], tempo: [] };

  // Helper function to calculate max values
  const getMax = (resultValue, metricArray) => Math.max(resultValue, Math.max(0, ...metricArray));

  // Collect metrics for the specified machineId and weight
  allSessions.forEach(({ exercises }) => {
    if (exercises) {
      exercises.forEach(
        ({
          machineId: exMachineId,
          weight: exWeight,
          qs_average,
          qs_range,
          qs_rhythm,
          qs_tempo,
        }) => {
          if (
            exMachineId === machineId &&
            exWeight === weight &&
            qs_average > 0 &&
            qs_range > 0 &&
            qs_rhythm > 0 &&
            qs_tempo > 0
          ) {
            metrics.total.push(qs_average);
            metrics.range.push(qs_range);
            metrics.rhythm.push(qs_rhythm);
            metrics.tempo.push(qs_tempo);
          }
        },
      );
    }
  });

  // Calculate max values for each metric
  thisWeight.average = getMax(results.average, metrics.total);
  thisWeight.rhythm = getMax(results.rhythm, metrics.rhythm);
  thisWeight.tempo = getMax(results.tempo, metrics.tempo);
  thisWeight.range = getMax(results.range, metrics.range);

  return thisWeight;
}

// function getLast5Session(results, allSessions, machineId) {
//   let total = [];
//   let range = [];
//   let rhythm = [];
//   let tempo = [];
//   let sessionsNumber = allSessions.length >= 5 ? -5 : -allSessions.length;
//   if (allSessions.length > 0) {
//     allSessions.slice(sessionsNumber).forEach((ele) => {
//       if (ele.exercises) {
//         ele.exercises.forEach((exercise) => {
//           if (exercise.machineId == machineId) {
//             if (
//               exercise.qs_average &&
//               exercise.qs_average > 0 &&
//               exercise.qs_range &&
//               exercise.qs_range > 0 &&
//               exercise.qs_rhythm &&
//               exercise.qs_rhythm > 0 &&
//               exercise.qs_tempo &&
//               exercise.qs_tempo > 0
//             ) {
//               total.push(exercise.qs_average);
//               range.push(exercise.qs_range);
//               rhythm.push(exercise.qs_rhythm);
//               tempo.push(exercise.qs_tempo);
//             }
//           }
//         });
//       }
//     });
//   }

//   let last5Session = { average: 0, rhythm: 0, tempo: 0, range: 0 };

//   if (results.average >= Math.max.apply(0, total)) {
//     last5Session.average = results.average;
//   } else {
//     last5Session.average = Math.max.apply(0, total);
//   }

//   if (results.rhythm >= Math.max.apply(0, rhythm)) {
//     last5Session.rhythm = results.rhythm;
//   } else {
//     last5Session.rhythm = Math.max.apply(0, rhythm);
//   }

//   if (results.tempo >= Math.max.apply(0, tempo)) {
//     last5Session.tempo = results.tempo;
//   } else {
//     last5Session.tempo = Math.max.apply(0, tempo);
//   }
//   if (results.range >= Math.max.apply(0, range)) {
//     last5Session.range = results.range;
//   } else {
//     last5Session.range = Math.max.apply(0, range);
//   }
//   console.log(last5Session);
//   return last5Session;
// }
function getLast5Session(results, allSessions, machineId) {
  const last5Session = {
    average: 0,
    rhythm: 0,
    tempo: 0,
    range: 0,
    average2: false,
    rhythm2: false,
    tempo2: false,
    range2: false,
  };
  const metrics = { total: [], range: [], rhythm: [], tempo: [] };

  // Helper function to calculate max values
  const getMax = (resultValue, metricArray) => Math.max(resultValue, Math.max(0, ...metricArray));

  // Get the last 5 sessions (or fewer if total sessions are less than 5)
  const recentSessions = allSessions.slice(-Math.min(5, allSessions.length));

  // Collect metrics from exercises in recent sessions
  recentSessions.forEach(({ exercises }) => {
    if (exercises) {
      exercises.forEach(({ machineId: exMachineId, qs_average, qs_range, qs_rhythm, qs_tempo }) => {
        if (
          exMachineId === machineId &&
          qs_average > 0 &&
          qs_range > 0 &&
          qs_rhythm > 0 &&
          qs_tempo > 0
        ) {
          metrics.total.push(qs_average);
          metrics.range.push(qs_range);
          metrics.rhythm.push(qs_rhythm);
          metrics.tempo.push(qs_tempo);
        }
      });
    }
  });

  // Calculate max values for each metric
  last5Session.average = getMax(results.average, metrics.total);
  last5Session.rhythm = getMax(results.rhythm, metrics.rhythm);
  last5Session.tempo = getMax(results.tempo, metrics.tempo);
  last5Session.range = getMax(results.range, metrics.range);

  return last5Session;
}

function getWeights(results, allSessions, machineId, options = {}) {
  const weights = {
    average: 0,
    rhythm: 0,
    tempo: 0,
    range: 0,
    average2: false,
    rhythm2: false,
    tempo2: false,
    range2: false,
  };
  const metrics = { total: [], range: [], rhythm: [], tempo: [] };

  const { weight = null, last5 = false } = options; // Optional parameters for weight and last5 sessions

  // Helper function to calculate max values
  const getMax = (resultValue, metricArray) => Math.max(resultValue, Math.max(0, ...metricArray));

  // Determine sessions to iterate over (all sessions or last 5)
  const sessionsToProcess = last5 ? allSessions.slice(0, 5) : allSessions;

  // Collect metrics from the specified sessions
  sessionsToProcess.forEach(({ exercises }) => {
    if (exercises) {
      exercises.forEach(
        ({
          machineId: exMachineId,
          weight: exWeight,
          qs_average,
          qs_range,
          qs_rhythm,
          qs_tempo,
        }) => {
          const weightCondition = weight !== null ? exWeight === weight : true; // Check if weight filtering is required
          if (exMachineId === machineId && weightCondition) {
            qs_average > 0 ? metrics.total.push(qs_average) : '';
            qs_range > 0 ? metrics.range.push(qs_range) : '';
            qs_rhythm > 0 ? metrics.rhythm.push(qs_rhythm) : '';
            qs_tempo > 0 ? metrics.tempo.push(qs_tempo) : '';
          }
        },
      );
    }
  });

  // Calculate max values for each metric
  weights.average = getMax(results.average, metrics.total);
  weights.rhythm = getMax(results.rhythm, metrics.rhythm);
  weights.tempo = getMax(results.tempo, metrics.tempo);
  weights.range = getMax(results.range, metrics.range);
  weights.average2 = results.average >= weights.average;
  weights.rhythm2 = results.rhythm >= weights.rhythm;
  weights.tempo2 = results.tempo >= weights.tempo;
  weights.range2 = results.range >= weights.range;

  return weights;
}

export {
  qs,
  getBestScore,
  getOverAllQs,
  computeQualityScores,
  // getAllWeights,
  // getThisWeight,
  // getLast5Session,
  getWeights,
};
